module.exports = __webpack_public_path__ + "fonts/iconfont.df4e0ce3.woff2";